import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import type { StageReorderInDto } from 'shared/domain/workflow/types';
import type { StageReorderRequestModel } from '../httpQueue/workflow/stageRequestRunner';

export interface ReorderStageUseCase {
  execute(
    stageId: string,
    stageReorderDto: StageReorderInDto,
    workflowId: string,
    projectId: string,
    uniqueId: string
  ): Promise<void>;
}

export class StageReorderer implements ReorderStageUseCase {
  constructor(
    private addRequest: (request: StageReorderRequestModel) => Promise<unknown>
  ) {}

  async execute(
    stageId: string,
    stageReorderDto: StageReorderInDto,
    workflowId: string,
    projectId: string,
    uniqueId: string
  ): Promise<void> {
    debugLog('StageReorderer.execute', stageId, stageReorderDto);
    const request: StageReorderRequestModel = {
      createdAt: Date.now(),
      method: 'PUT',
      url: `/project/${projectId}/workflow/${workflowId}/stage/${stageId}/order`,
      data: {
        stageReorderDto,
        stageId,
        workflowId,
        projectId,
        uniqueId,
      },
      entityType: HttpRequestModelType.workflowStageReorder,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const stageReorderer = new StageReorderer(addRequest);
